/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleALeftIcon20Light = forwardRef('ArrowShapeTriangleALeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 5.121a1.1 1.1 0 0 0-1.71-.915L4.97 9.085a1.1 1.1 0 0 0 0 1.83l7.319 4.88a1.1 1.1 0 0 0 1.71-.916V5.121Zm-1.156-.083a.1.1 0 0 1 .156.083v9.758a.1.1 0 0 1-.156.083l-7.318-4.878a.1.1 0 0 1 0-.167l7.318-4.879Z" })));
});
